import React, { Fragment } from 'react'
const App = (props) => {
  let { product } = props

  const featureList = (product.featureList || []).map((feat) => {
    return (
      <li class="list-group-item">
        <Fragment>
          <div dangerouslySetInnerHTML={{ __html: feat }}></div>
        </Fragment>
      </li>
    )
  })

  if (product) {
    return (
      <div className="product-card">
        <div className="panel-default">
          <div
            className="panel-heading"
            style={{ backgroundColor: product.headingFieldColor }}
          >
            <div class="pricely-label">
              <strong>{product.heading}</strong>
              <strong>{product.subheading}</strong>
            </div>
            <div class="pricely-figure">
              <div
                class="pricely-amount"
                dangerouslySetInnerHTML={{ __html: product.priceText }}
              ></div>
            </div>
            <div
              class="pricely-foreword ne"
              data-gramm="false"
              contenteditable="false"
            >
              {product.priceSubHeading || ''.trim().length ? (
                product.priceSubHeading
              ) : (
                <Fragment>&nbsp;</Fragment>
              )}
            </div>
          </div>
          <ul class="list-group">{featureList}</ul>
        </div>
        {product.link ? (
          <a href={product.link} target="_parent" class="buy-btn">
            <span class="elButtonMain">{product.buttonText}</span>
            <span class="elButtonSub"></span>
          </a>
        ) : (
          <a onClick={props.onClick} class="buy-btn">
            <span class="elButtonMain">{product.buttonText}</span>
            <span class="elButtonSub"></span>
          </a>
        )}
      </div>
    )
  } else {
    return <div>Loading</div>
  }
}

export default App
